import React, { ReactElement } from 'react';
import { Rocket } from 'lucide-react';

const Banner = (): ReactElement | null => {
  return (
    <div className="relative bg-[#0A0A0A]">
      <div className="mx-auto py-3 px-3">
        <div className="flex items-center justify-between flex-wrap">
          <div className="w-0 flex-1 flex items-center justify-center">
            <p className="font-medium text-white text-center flex items-center">
              <Rocket size={20} />
              <span className="inline-block ml-2">
                You&apos;re viewing the legacy version, available through May 15th.
              </span>
              <span className="inline-block ml-2">
                <a
                  href="http://s2sync.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white underline font-semibold hover:text-blue-100 transition-colors"
                >
                  Return to the new S2 Sync Experience →
                </a>
              </span>
            </p>
          </div>
          <div className="flex-shrink-0">
            {/* <button
              type="button"
              onClick={handleDismiss}
              className="flex p-2 rounded-md hover:bg-blue-800 focus:outline-none focus:ring-2 focus:ring-white transition-colors"
              aria-label="Dismiss banner"
            >
              <XIcon className="h-5 w-5 text-white" aria-hidden="true" />
            </button> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
